












































import { Component, Vue } from 'vue-property-decorator';

@Component
export default class RecruitmentNavigationDrawer extends Vue {
  private menuContentFields = [
    {
      title: 'ダッシュボード',
      icon: 'mdi-monitor-dashboard',
      route: 'recruitmentDashboard',
      index: 0,
    },
    {
      title: '求人案件',
      icon: 'mdi-note-text-outline',
      route: 'recruitmentJobList',
      index: 1,
    },
    { title: '候補者',
      icon: 'mdi-account-group-outline',
      route: 'recruitmentCandidateList',
      index: 2
    },
    {
      title: '人材検索',
      icon: 'mdi-magnify',
      route: 'humanResourceSearch',
      index: 3,
    },
  ];

  private selectedMenu(index: number) {
    const selectedMenu = this.menuContentFields.find(
      (x: any) => x.index === index
    );
    if (selectedMenu) {
      this.$router.push({ name: selectedMenu.route });
    }
  }

  private isSelectMenu(index: number) {
    const selectedMenu = this.menuContentFields.find(
      (x: any) => x.index === index
    );
    if (selectedMenu) {
      if (this.$route.name === selectedMenu.route) return true;
    } else {
      return false;
    }
  }
}
